<template>
  <div class="index_body">
    <Logo :logolink="logoLink" />
    <mbtns />
    <div class="middleBg">
      <div :class="{'item vr_panorama index2':step==3,'item vr_panorama':step!==3}" v-if="vrUrl">
       
      </div>
      <div :class="{'item wzdt index2':step==2,'item wzdt':step!==2}" v-if="wzdtUrl">
       
        <a :href="wzdtUrl" target="_blank">
          <img :src="wzduImgUrl" />
        </a>
      </div>
      <img :src="indexBg" alt />
    </div>
    <pcbtns></pcbtns>

    <img :src="qrimg" alt="QR code" class="qr_code" />
    <div class="explain">手机端请扫码</div>
    
    <ul class="bottom mBottom">
      <li
        v-for="(item,index) in bottomItems"
        :key="index"
        @click="routerPush(item)"
        @mouseover="bottomHover(index,true)"
        @mouseout="bottomHover(index,false)"
      >
        <div :class="{'icon icon_normal_pos':item.isNormal,'icon icon_active_pos':item.isActive}">
          <img :src="base_url().img_baseurl+item.ChapterThemeImg.visitimg+'?v='+$version" alt />
          <div class="name">{{item.name}}</div>
        </div>
      </li>
      <li class="ren"></li>
    </ul>
    <ul class="bottom pcBottom">
      <li
        v-for="(item,index) in bottomItems"
        :key="index"
        @click="routerPush(item)"
        @mouseover="bottomHover(index,true)"
        @mouseout="bottomHover(index,false)"
      >
        <div class="top" v-show="item.show"></div>
        <div class="folding_angle" v-show="item.show"></div>
        <div :class="{'icon icon_normal_pos':item.isNormal,'icon icon_active_pos':item.isActive}">
         <img :src="base_url().img_baseurl+item.ChapterThemeImg.visitimg+'?v='+$version" alt />
          <div class="name">{{item.name}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Logo from "../components/Logo";
import mbtns from "../components/mbtns";
import pcbtns from "../components/pcbtns";
export default {
  name: "Index",
  components: {
    Logo,
    mbtns,
    pcbtns,
  },
  data() {
    return {
      bottomItems: [],
      wzdtUrl: "",
      wzduImgUrl: "",
      vrUrl: "",
      vrImgUrl: "",
      logoImgUrl: "",
      indexBg: "",
      logoLink: "",
      qrimg: "",
      step:''
    };
  },
  created() {
    this.vrImgUrl =
      this.base_url().img_baseurl + "/images/VRquanjing.png?v=" + this.$version;
    this.wzduImgUrl =
      this.base_url().img_baseurl +
      "/images/wanzhuandatu.png?v=" +
      this.$version;
    this.indexBg =
      this.base_url().img_baseurl + "/images/indexBg.png?v=" + this.$version;
    this.qrimg =
      this.base_url().img_baseurl + "/images/bd_qr.png?v=" + this.$version;
    //设置title
    this.setGlobleTitle(this.globleTitle);
    this.wzdtUrl = this.base_url().wanZhanDaTuUrl;
    this.vrUrl = this.base_url().vrUrl;
    this.logoLink = this.base_url().logoLink;
    this.$http.post(this.base_url().baseurl + "/xszl/api/Chapter/index").then(
      (res) => {
        let data = JSON.parse(res.body.Chapter);
       
        //云南大学的
        var pageBgArray = [
          "#fff4ef",
          "#ffffff",
          "#ffeedd",
          "#fefae4",
          "#efeef2",
          "#f1f5ef",
          "#d7f2ff",
        ];
        var colorArray = [
          {
            normalStyle: {
              background: "#d8d9bd",
              color: "#7b766b",
            },
            activeStyle: {
              color: "#7b766b",
              background: "#edeee1",
            },
          },
          {
            normalStyle: {
              background: "#d8d9bd",
              color: "#9f7d72",
            },
            activeStyle: {
              color: "#9f7d72",
              background: "#edeee1",
            },
          },
          {
            normalStyle: {
              background: "#ffccc1",
              color: "#9b7a6f",
            },
            activeStyle: {
              color: "#9b7a6f",
              background: "#ffebd7",
            },
          },

          {
            normalStyle: {
              background: "#ffe0bb",
              color: "#fc696c",
            },
            activeStyle: {
              color: "#fc696c",
              background: "#fef9e2",
            },
          },
          {
            normalStyle: {
              background: "#c9bab4",
              color: "#fc696c",
            },
            activeStyle: {
              color: "#fc696c",
              background: "#efeef2",
            },
          },

          {
            normalStyle: {
              background: "#c9bab4",
              color: "#797155",
            },
            activeStyle: {
              color: "#797155",
              background: "#f1f5ef",
            },
          },
          {
            normalStyle: {
              background: "#3ba0b7",
              color: "#278698",
            },
            activeStyle: {
              background: "#bbe9ff",
              color: "#278698",
            },
          },
        ];
        if (data && data.length) {
          //云南大学的
          var styleIndex = 0;
          var pageBgIndex = 0;
          for (let i = 0; i < data.length; i++) {
            data[i].isNormal = true;
            data[i].show = false;
            data[i].isActive = false;
            //云南大学的
            styleIndex++;
            pageBgIndex++;
            if (styleIndex >= colorArray.length) {
              styleIndex = 0;
            }
            if (pageBgIndex >= pageBgArray.length) {
              pageBgIndex = 0;
            }
            data[i].normalStyle = colorArray[styleIndex].normalStyle;
            data[i].activeStyle = colorArray[styleIndex].activeStyle;
            data[i].chapterPageBg = pageBgArray[pageBgIndex];
            
          }
          this.bottomItems = data;
        }
      },
      (res) => {
        console.log("请求失败处理", res); //失败处理
      }
    );
  },
  methods: {
  
    routerPush(item) {
      // 云南大学的
      var currentIndexItem = JSON.stringify(item);
      sessionStorage.setItem("currentIndexItem", currentIndexItem);
      if (item.name == "馆长寄语") {
        this.routerLink("gzjy");
      } else {
        this.$router.push({
          path: "/Chapter",
          query: { id: item.id, name: item.name },
        });
      }
    },
    routerLink(id) {
      this.$router.push({ path: "/Content", query: { id: id } });
    },
    bottomHover(index, isHoverStart) {
      let bottomItems = this.bottomItems;
      if (isHoverStart) {
        for (let i = 0; i < bottomItems.length; i++) {
          if (i == index) {
            bottomItems[i].show = true;
            bottomItems[i].isActive = true;
            bottomItems[i].isNormal = false;
            break;
          }
        }
      } else {
        for (let i = 0; i < bottomItems.length; i++) {
          if (i == index) {
            bottomItems[i].show = false;
            bottomItems[i].isActive = false;
            bottomItems[i].isNormal = true;
            break;
          }
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../css/index.css";
</style>
